import { Box, Divider, Stack } from "@mui/material";
import { ScreenerFinish, ScreeningHeader } from "./ScreeningHeader";
import QuestionItemWrapper from "../Responses/QuestionItemWrapper";
import ConfirmationModalWrapper from "../Responses/ConfirmationModalWrapper";
import CalculationWrapper from "../Responses/CalculationWrapper/CalculationWrapper";

const ScreeningAttempt = ({ languages, refreshPage }: any) => {
  return (
    <Stack sx={{ height: "100vh" }}>
      <ScreeningHeader languages={languages} refreshPage={refreshPage} />
      <Divider />
      <Box sx={{ p: 2 }}>
        <QuestionItemWrapper />
        <Box sx={{ mt: 2, display: "flex", justifyContent: "flex-end" }}>
          <ScreenerFinish />
        </Box>
      </Box>

      <ConfirmationModalWrapper />
      <CalculationWrapper />
    </Stack>
  );
};
export default ScreeningAttempt;
